export const CARD_NUMBER_FORMAT = 'xxxx xxxxxx xxxxxx xxxxxxx';

// eslint-disable-next-line max-len
export const giftCardPinImgUrl = 'https://secure2.homedepot.com/hdus/en_US/DTCCOM/common/giftcard/Images/WhereDoIFindPIN-newCardV4-withoutTitle.jpg';

export const storeLocatorUrl = 'https://www.homedepot.com/l/store-locator';
export const MAX_BALANCE_AMT = 2000;
export const URL = {
  viewBalance: '/gift-cards/balance',
  plp: '/c/gift-cards',
  faq: '/c/Gift_Card_FAQ'
};
export const VERBIAGE = {
  checkBalanceAndReload: 'Check Balance and Reload',
  reloadGiftCard: 'Reload Gift Card',
  checkAnotherBalance: 'Check Another Balance',
  backToGiftCards: 'Back to Gift Cards',
  reloadErrorMsg: `Gift cards can't exceed $${MAX_BALANCE_AMT}.`,
  maxBalanceReached: 'Maximum balance reached. Gift cards can\'t exceed $2000.',
  limitReached: 'You\'ve reached the 24 hour limit for purchasing gift cards.',
  technicalError: 'Sorry, we\'re experiencing technical difficulties. Please try again later.',
  selectAmount: 'Select Amount',
  continue: 'Continue',
  cancel: 'Cancel',
  enterAmount: 'Please enter an amount',
  invalidNumberDesktop: 'Invalid number. Please double-check your card details',
  invalidNumberMobile: 'or try scanning the barcode',
  pinTitle: 'Where is my PIN?',
  holdAmountErr:
    'This card has funds on hold and can\'t be reloaded at this time. Please try again later.',
  saveToAccount: 'Save this Gift Card to My Account',
  saveToAccountSuccess: 'Gift Card successfully added to account'
};

export const GIFTCARD_RELOAD_AMOUNTS = [100, 200, 300, 500];
export const MINIMUM_CUSTOM_AMOUNT = 1;
export const MINIMUM_CARD_AMOUNT = 5;
// programs that not allowed to check balance online
export const CHECK_BALANCE_RESTRICTED_PROGRAM = ['69', '79'];

// Programs that not allowed to reload online
export const RELOAD_RESTRICTED_PROGRAM = ['24', '39'];

export const addToCartPayload = {
  filterItem: true,
  localization: {
    primaryStoreId: 121
  },
  cartAttr: {
    essentialAccessories: true
  },
  items: {
    delivery: [
      {
        itemId: '999999999',
        storeSKU: '999741',
        quantity: '1',
        type: 'bopis',
        location: '0121',
        config: {
          type: 'GIFTCARD_RELOAD'
        }
      }
    ]
  }
};
export const NUCLEUS_CHECKOUT_PATH = '/checkout/giftcard-reload';
export const AUTH_PATH = '/auth/view/signin?redirect=/gift-cards/balance/ ';

export const containerWidthClass = 'sui-w-96';

export const FEATURE_SWITCH = {
  DISABLE_GIFT_CARD_RELOAD: 'disableGiftCardReload',
  RECAPTCHA: 'reCaptchaEnabled'
};

export const ERRORS = {
  CHECK_BALANCE: [
    'CUST_PAY_ERR_4004', // Wrong card number or pin
    'CUST_PAY_ERR_4029', // Wrong card number or pin
    'CUST_PAY_ERR_5004', // reCaptcha error
    'CUST_PAY_ERR_5005', // Problem with gift card info
    'CUST_PAY_ERR_5012', // verify reCaptcha error
    'CART_GEN_ERR',
    'CUST_PAY_GEN_ERR'
  ],
  RELOAD: [
    'CUST_PAY_ERR_4030', // Gift card funds on hold
    'CUST_PAY_ERR_4031', // Gift card reload failed
    'CUST_PAY_ERR_4027', // Gift card max out
    'CUST_PAY_ERR_4028', // Gift card daily amount limit
    'CART_GEN_ERR',
    'CUST_PAY_GEN_ERR'
  ],
  SAVE_TO_ACCOUNT: ['GC_ERR_1002', 'CUST_PAY_ERR_5015'],
  AUTH: ['CUST_PAY_ERR_4000']
};

export const ERROR_MESSAGES = {
  DISABLE_GIFTCARD_RELOAD_HEADLINE: 'Reloading gift cards is unavailable at this time',
  DISABLE_GIFTCARD_RELOAD_MESSAGE: 'Please come back and try again later.',
};

export const NEW_RELIC_ACTIONS = {
  SUBMIT_RELOAD_BUTTON_CLICKED: 'submitReloadButtonClicked',
  SUBMIT_RELOAD_BUTTON_SUCCESS: 'submitReloadButtonSuccess',
  SUBMIT_RELOAD_BUTTON_FAIL: 'submitReloadButtonFail',
  RELOAD_BUTTON_CLICKED: 'reloadButtonClicked',
};
